import {
  cva
} from "../../../chunk-6A7LB5UJ.mjs";
import "../../../chunk-QJVDQ4DQ.mjs";
import "../../../chunk-D57E6H3M.mjs";

// src/components/primitive/Badge/BadgeOverlay.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var indicatorVariants = cva("buyscout-badge-overlay__indicator", {
  variants: {
    color: {
      primary: "buyscout-badge-overlay__indicator--color-primary",
      success: "buyscout-badge-overlay__indicator--color-success",
      error: "buyscout-badge-overlay__indicator--color-error"
    },
    anchor: {
      "top-end": "buyscout-badge-overlay__indicator--anchor-top-end",
      "bottom-end": "buyscout-badge-overlay__indicator--anchor-bottom-end"
    },
    dot: {
      true: "buyscout-badge-overlay__indicator--dot",
      false: ""
    },
    overlap: {
      rectangular: "",
      circular: "buyscout-badge-overlay__indicator--overlap-circular"
    }
  },
  defaultVariants: {
    color: "error",
    anchor: "top-end",
    dot: false,
    overlap: "rectangular"
  }
});
function BadgeOverlay({
  ref,
  count,
  max = 99,
  dot = false,
  showZero = false,
  color,
  anchor,
  overlap,
  className,
  children,
  ...rest
}) {
  const resolved = count ?? 0;
  const show = dot || resolved > 0 || resolved === 0 && showZero;
  const display = resolved > max ? `${max}+` : `${resolved}`;
  return /* @__PURE__ */ jsxs("span", { ref, className: ["buyscout-badge-overlay", className].filter(Boolean).join(" "), ...rest, children: [
    children,
    show ? /* @__PURE__ */ jsx("span", { "aria-hidden": true, className: indicatorVariants({ color, anchor, dot, overlap }), children: dot ? null : display }) : null
  ] });
}
BadgeOverlay.displayName = "BadgeOverlay";
export {
  BadgeOverlay
};
//# sourceMappingURL=BadgeOverlay.mjs.map